export const common = {
  signIn: "Log in",
  inbox: "Inbox",
  create: "Create",
  home: "Home",
  listings: "Listings",
  myPage: "My page",
  close: "Close",
  cancel: "Cancel",
  save: "Save",
  delete: "Delete",
  edit: "Edit",
  tryAgain: "Try again",
  toStartPage: "Go to start page",
  more: "More",
  search: "Search",
  loading: "Loading…",
  free: "Free",
  price: "Price",
  kr: "kr",
  sold: "Sold",
  paused: "Paused",
  today: "Today",
  yesterday: "Yesterday",
  unread: "unread",
  openOnWeb: "Open on web",
  webBanner: "Purchases and upgrades are made on sellavo.com",
  quickMenu: "Quick menu",
  language: "Language",
  country: "Country",
  sellCountry: "Selling country",
  sellCountryHint: "Controls where the item is sold and which locations are shown.",
} as const;
